class FaqAccordion extends HTMLElement {
  constructor() {
    super();
    this.isAnimating = false;
    this.onTriggerClick = this.onTriggerClick.bind(this);
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.faq-item'));
    this.singleOpen = this.dataset.singleOpen === 'true';

    this.items.forEach((item) => {
      const trigger = item.querySelector('.faq-item__trigger');
      const panel = item.querySelector('.faq-item__panel');
      const isOpen = item.classList.contains('is-open');

      if (!trigger || !panel) return;

      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        panel.hidden = false;
        panel.style.height = 'auto';
        panel.style.opacity = '1';
      } else {
        panel.hidden = true;
        panel.style.height = '0px';
        panel.style.opacity = '0';
      }

      trigger.addEventListener('click', this.onTriggerClick);
    });
  }

  disconnectedCallback() {
    if (!this.items) return;

    this.items.forEach((item) => {
      const trigger = item.querySelector('.faq-item__trigger');
      if (trigger) trigger.removeEventListener('click', this.onTriggerClick);
    });
  }

  onTriggerClick(event) {
    const item = event.currentTarget.closest('.faq-item');
    if (!item || this.isAnimating) return;

    const shouldOpen = !item.classList.contains('is-open');

    if (shouldOpen && this.singleOpen) {
      this.items.forEach((otherItem) => {
        if (otherItem !== item && otherItem.classList.contains('is-open')) {
          this.closeItem(otherItem, false);
        }
      });
    }

    if (shouldOpen) {
      this.openItem(item);
    } else {
      this.closeItem(item, true);
    }
  }

  openItem(item) {
    const trigger = item.querySelector('.faq-item__trigger');
    const panel = item.querySelector('.faq-item__panel');
    if (!trigger || !panel) return;

    this.isAnimating = true;
    panel.hidden = false;
    panel.style.height = '0px';
    panel.style.opacity = '0';
    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(() => {
      const contentHeight = panel.scrollHeight;
      panel.style.transition = 'height 320ms cubic-bezier(0.22, 1, 0.36, 1), opacity 220ms ease';
      panel.style.height = `${contentHeight}px`;
      panel.style.opacity = '1';

      this.onTransitionEnd(panel, () => {
        panel.style.height = 'auto';
        this.isAnimating = false;
      });
    });
  }

  closeItem(item, trackAnimation) {
    const trigger = item.querySelector('.faq-item__trigger');
    const panel = item.querySelector('.faq-item__panel');
    if (!trigger || !panel) return;

    if (trackAnimation) {
      this.isAnimating = true;
    }

    panel.hidden = false;
    panel.style.height = `${panel.scrollHeight}px`;
    panel.style.opacity = '1';
    trigger.setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');

    requestAnimationFrame(() => {
      panel.style.transition = 'height 280ms cubic-bezier(0.4, 0, 0.2, 1), opacity 180ms ease';
      panel.style.height = '0px';
      panel.style.opacity = '0';

      this.onTransitionEnd(panel, () => {
        panel.hidden = true;
        if (trackAnimation) {
          this.isAnimating = false;
        }
      });
    });
  }

  onTransitionEnd(panel, callback) {
    const handleTransitionEnd = (event) => {
      if (event.target !== panel || event.propertyName !== 'height') return;
      panel.style.transition = '';
      panel.removeEventListener('transitionend', handleTransitionEnd);
      callback();
    };

    panel.addEventListener('transitionend', handleTransitionEnd);
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FaqAccordion);
}
